import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "video",
        options: {
          src: `${config.ASSETS_URL}/01/25/principle/velocity-smaller.m4v`,
          loop: true,
          autoplay: true,
        },
      },
      styles: {
        padding: "12.04% 0",
      },
    },
  },
];

export default components;
